// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1KaRl","imageUploader":"EGiftCard_imageUploader__2FLGT"};